module.exports = __webpack_public_path__ + "media/wordsswap.be3728fb.mp4";